import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrder, SearchQueryOrderDirection } from "types/generated";

export enum SPACE_STACKS_COLUMN_ID {
  NAME = "NAME",
  STATE = "STATE",
  LABELS = "LABELS",
  ROLE = "ROLE",
  GRANTED_VIA = "GRANTED_VIA",
}

export const SPACE_STACKS_COLUMNS_STORAGE_KEY = "spaceDetailsStacksColumnsConfig";
export const SPACE_STACKS_LIMIT_STORAGE_KEY = "spaceDetailsStacksLimit";
export const SPACE_STACKS_FILTERS_ORDER_KEY = "spaceDetailsStacksFiltersOrder";
export const SPACE_STACKS_INITIAL_LIMIT = 50;

// The URL param backing the "Include stacks from other spaces" toggle (StackAccessMode).
export const SPACE_STACKS_INCLUDE_OTHER_SPACES_URL_PARAM = "includeOtherSpaces";

// Name goes first: the expand chevron and the sub-row tree connector anchor on the first
// column, and grant sub-rows have no state/labels to show there.
export const SPACE_STACKS_COLUMN_CONFIG: Record<SPACE_STACKS_COLUMN_ID, TableColumnMeta> = {
  [SPACE_STACKS_COLUMN_ID.NAME]: {
    id: SPACE_STACKS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: 2000,
    resizable: false,
    allowsSorting: true,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_STACKS_COLUMN_ID.STATE]: {
    id: SPACE_STACKS_COLUMN_ID.STATE,
    title: "State",
    minWidth: 200,
    defaultWidth: 200,
    maxWidth: 200,
    allowsSorting: true,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_STACKS_COLUMN_ID.LABELS]: {
    id: SPACE_STACKS_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: 400,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_STACKS_COLUMN_ID.ROLE]: {
    id: SPACE_STACKS_COLUMN_ID.ROLE,
    title: "Role",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: 400,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_STACKS_COLUMN_ID.GRANTED_VIA]: {
    id: SPACE_STACKS_COLUMN_ID.GRANTED_VIA,
    title: "Granted via",
    tooltip:
      "Shows the access origin: a direct assignment on this space, inheritance from a parent space, or read-only access reaching up from a child space",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: 400,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
};

// Only name and state have backend order keys; role/space are filter-only aggregates and
// granted-via has no order key at all.
export const SPACE_STACKS_SORT_CONFIG: Record<string, string> = {
  [SPACE_STACKS_COLUMN_ID.NAME]: "name",
  [SPACE_STACKS_COLUMN_ID.STATE]: "state",
};

export const SPACE_STACKS_INITIAL_ORDER_BY: SearchQueryOrder = {
  field: SPACE_STACKS_SORT_CONFIG[SPACE_STACKS_COLUMN_ID.NAME],
  direction: SearchQueryOrderDirection.Asc,
};
